module.exports = {"minify":true,"options":["setClasses"],"feature-detects":["touchevents","css/fontface","css/backgroundsize","history","inputtypes"]}


//////////////////
// WEBPACK FOOTER
// ./.modernizrrc
// module id = sRo2
// module chunks = 0